import { SVGProps } from "react";

export default function DashboardOnboardingCheckIcon(
  props: SVGProps<SVGSVGElement>,
) {
  const { height = 24, width = 24, ...rest } = props;

  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M5 12L10 17L20 7"
        stroke="#E3592E"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
